import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration, UzurvRestService } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Journey } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class JourneyService extends UzurvRestService {
  readonly resourceUrl = 'journeys/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Manually pair a driver with a journey
   *
   * @param journeyId
   * @param driverId
   * @permission ride_request_update
   */
  manuallyPairJourneyWithDriver(journeyId: number, driverId: number): Observable<Journey> {
    return this.patch(`${this.resourceUrl}${journeyId}`, {
      id: journeyId,
      paired: true,
      driverId: driverId
    }).pipe(map(response => Deserialize(response, Journey)));
  }
}
